import { render, staticRenderFns } from "./TermsAndConds.vue?vue&type=template&id=490492af&scoped=true&"
import script from "./TermsAndConds.vue?vue&type=script&lang=js&"
export * from "./TermsAndConds.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConds.vue?vue&type=style&index=0&id=490492af&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490492af",
  null
  
)

export default component.exports